export default __webpack_public_path__ + "static/media/login-link.7d50895c.png";